/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-panel-footer-padding: Specifies the padding of the component's footer.
 * @prop --calcite-panel-header-border-block-end: Specifies the component header's block end border.
 */

:host {
  @extend %component-host;
  @apply relative flex w-full h-full flex-auto;

  --calcite-min-header-height: calc(var(--calcite-icon-size) * 3);
}

@include disabled();

@import "../../assets/styles/header";

.container {
  @apply bg-background m-0 flex w-full flex-auto flex-col items-stretch p-0;

  transition: max-block-size var(--calcite-animation-timing), inline-size var(--calcite-animation-timing);
}

.container[hidden] {
  @apply hidden;
}

.header {
  @apply bg-foreground-1 flex flex-col
    z-header;
  border-block-end: var(--calcite-panel-header-border-block-end, 1px solid var(--calcite-color-border-3));
}

.header-container {
  @apply flex flex-row w-full
  items-stretch
  justify-start;
  flex: 0 0 auto;
}

.header-container--border-end {
  border-block-end: 1px solid var(--calcite-color-border-3);
}

.action-bar-container {
  @apply w-full;
}

.action-bar-container ::slotted(calcite-action-bar) {
  @apply w-full;
}

.header-content {
  @apply flex
    flex-col
    overflow-hidden
    px-3
    py-3.5;
  margin-inline-end: auto;
  .heading,
  .description {
    @apply block
      break-words
      p-0;
  }
  .heading {
    @apply text-0h mx-0 mt-0 mb-1 font-medium;
    &:only-child {
      @apply mb-0;
    }
  }
  .description {
    @apply text-color-2 text-n1h;
  }
}

.back-button {
  @apply border-color-3
  border-0
  border-solid;
  border-inline-end-width: theme("borderWidth.DEFAULT");
}

.header-actions {
  @apply flex
  flex-row
  flex-nowrap
  items-stretch;
}

.header-actions--end {
  margin-inline-start: theme("margin.auto");
}

.content-wrapper {
  @apply flex
  flex-auto
  flex-col
  flex-nowrap
  items-stretch
  bg-background
  overflow-auto
  h-full;
}

.footer {
  @apply bg-foreground-1
  flex
  w-full
  justify-evenly;

  flex: 0 0 auto;
  padding: var(--calcite-panel-footer-padding, theme("spacing.2"));
  border-block-start: 1px solid var(--calcite-color-border-3);
}

.fab-container {
  @apply sticky
  bottom-0
  my-0
  mx-auto
  block
  p-2
  z-sticky;
  inset-inline: 0;
  inline-size: fit-content;
}

@include base-component();
